module.exports = __webpack_public_path__ + "img/icon_tools_user.d5353da5.svg";